import React from 'react'

import PropTypes from 'prop-types'
import { Route, generatePath } from 'react-router-dom'

import useAuthGuest from 'hooks/useAuthGuest'
import * as service from 'service'

const DefaultComponent = ({ children }) => <>{children}</>

const GuestRouteWithLayout = ({
  auth,
  layout,
  component: Component,
  guestModule,
  redirectPath,
  redirect = true,
  ...rest
}) => {
  const Layout = layout || DefaultComponent
  const isAuthenticated = service.guestPortal.auth.isAuthenticated()
  const { homeRoute, loadOut, organizationSlug, portalToken } = useAuthGuest()

  const resolvedRedirectPath =
    redirectPath && organizationSlug
      ? generatePath(redirectPath, { organizationSlug })
      : redirectPath

  if (isAuthenticated) {
    if (redirect && !auth && homeRoute) {
      service.history.push(homeRoute)
      return null
    }
  } else {
    if (auth) {
      service.guestPortal.auth.logout(portalToken, organizationSlug)
      loadOut()
      return null
    }
  }

  const renderRoute = (matchProps) => (
    <Layout
      auth={auth}
      guestModule={guestModule}
      redirectPath={resolvedRedirectPath}
    >
      <Component {...matchProps} />
    </Layout>
  )

  return <Route {...rest} render={(matchProps) => renderRoute(matchProps)} />
}

GuestRouteWithLayout.propTypes = {
  auth: PropTypes.bool,
  component: PropTypes.any,
  guestModule: PropTypes.string,
  layout: PropTypes.any,
  path: PropTypes.string,
  redirect: PropTypes.bool,
  redirectPath: PropTypes.string,
}

export default GuestRouteWithLayout
